import { CaretDownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Space } from 'antd';
import React from 'react';

type Variable = { label: string; value: string };

export interface ToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
  image?: boolean;
  video?: boolean;
  variables?: Variable[];
  onInsertVariable?: (variable: Variable) => void;
}

const Toolbar = ({
  image = true,
  video = true,
  variables = [],
  onInsertVariable,
  ...props
}: ToolbarProps) => {
  return (
    <div {...props}>
      <span className="ql-formats">
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-script" value="sub" />
        <button className="ql-script" value="super" />
        <button className="ql-strike" />
        <button className="ql-clean" />
      </span>
      <span className="ql-formats">
        <select className="ql-font" />
        <select className="ql-header" />
        <button className="ql-blockquote" />
        <button className="ql-code" />
      </span>
      <span className="ql-formats">
        <select className="ql-background" />
        <select className="ql-color" />
      </span>
      <span className="ql-formats">
        <button className="ql-list" value="ordered" />
        <button className="ql-list" value="bullet" />
        <select className="ql-align" />
        <button className="ql-indent" value="-1" />
        <button className="ql-indent" value="+1" />
      </span>
      <span className="ql-formats">
        <button className="ql-link" />
        {image && <button className="ql-image" />}
        {video && <button className="ql-video" />}
      </span>
      {variables.length > 0 && (
        <span className="ql-formats">
          <Dropdown
            trigger={['click']}
            menu={{
              onClick: (info) =>
                onInsertVariable &&
                onInsertVariable(variables.find(({ value }) => value === info.key) as Variable),
              items: variables.map(({ label, value }) => ({
                label,
                key: value,
              })),
            }}
          >
            <Button>
              <Space>
                Variáveis
                <CaretDownOutlined />
              </Space>
            </Button>
          </Dropdown>
        </span>
      )}
    </div>
  );
};

export default Toolbar;
